import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator, MatSelectChange, MatSort, MatTableDataSource } from "@angular/material";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { ToastrService } from "ngx-toastr";
import beautify from "xml-beautifier";
import { LoginService } from "src/app/components/Shared/Service/login_service";
import { DashboarduiService } from "../Shared/Service/dashboardui.service";
import { interval } from "rxjs";
import { IDropdownSettings } from "ng-multiselect-dropdown";

export const MY_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "LL",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

export class idsProductList {
  echotoken: any;
  totalrows: number;
  id: number;
  pmscode: String;
  processstatus: String;
  rateType: String;
  mealPlanCode: any;
  startdt: any;
  enddt: any;
  receivedXML: any;
  receivedDate: any;
  postedXML: any;
  postedDate: any;
  responseXML: any;
  responseDate: any;
}

@Component({
  selector: 'app-rate-sync-fortune',
  templateUrl: './rate-sync-fortune.component.html',
  styleUrls: ['./rate-sync-fortune.component.css'],
  providers: [
    LoginService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class RateSyncFortuneComponent implements OnInit {
  XMLName:any
  math = Math;
  SearchAllParams: any;
  searchText: any;
  echoToken: any
  public PGF: any = 0;
  public PGT: any = 50;
  pageSize = 50;
  public pageIndex = 0;
  // pageSizeOptions: number[] = [50, 100, 250, 500];
  isIDSUser: any;
  apiresult: any;
  hotellistChannel: any[];
  hotellistproperty: any;
  ResponseDisplay: boolean;
  ReceivedDisplay: boolean;
  ChannelPMSDisplay: boolean;
  ColumnHeader: boolean;
  errorResponse: string;
  errorMsgDisplay: boolean;
  XMLTitle: string;
  status: void;
  hotelSearchDataStatus: any;
  heartBeatData: any;
  errorMessage: string;
  errorMsgSubscription: boolean;
  displayContent: boolean;
  productType: any;
  currentDateStore: any;
  storeHeartBeatValue: any;
  blinkOfflineHotel: boolean;
  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private datePipe: DatePipe, public loginService: LoginService) { }
  today = new Date();
  display: Boolean = false;
  totalcount: any = 0;
  hotellistCopy: any = [];
  StorelstRestr: any;
  Val: string;
  selectedProperty: string;
  source = "FX2FN";
  selectedChannel: any;
  defaultData: any = [];
  // p: Number = 1;
  // count: Number = 50;
  User: string;
  selectedDate: any = new Date();
  selectedTOODate: any = new Date();
  todayFuture:any = new Date();
  todayFutureOneDay: any = new Date(this.todayFuture.setDate(this.todayFuture.getDate() + 1));
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  // public LOGS: any;
  lstgetcmlist: any[];
  hotellist: any = [];
  allproperty: any[];
  selected: string;
  Userid: any = [];
  displayedColumns: string[] = ['Status', 'rateCode', 'ReceivedDH', 'ReceivedXML', 'postedDate', 'echotoken'];

    /* Search Field */
    dropdownSettingsDept: IDropdownSettings = {};
    selectedDeptItems: any;
    dropdownDeptData: any
    searchBarFilter: boolean = false;
    addBtnDisabledFunc: boolean = true;
    idsProductList: idsProductList[] = [];
    dataSource: MatTableDataSource<idsProductList>
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    hideSearchFilter(){
      this.searchText = '';
      this.searchBarFilter = false
      
    }
  ngOnInit() {
    // this.isIDSUser = this.loginService.isIDSUser();
    this.isProgressing = true;
    this.errorMsgSubscription = true
    this.errorMessage = "Please select property and load"
    this.displayContent = false
      this.callIDSUsersProperties();
      this.dropdownSettingsDept = {
        idField: 'pmscode',
        textField: 'pmsname',
        allowSearchFilter: true,
        singleSelection: true,
        enableCheckAll: false,
        closeDropDownOnSelection:true,
        itemsShowLimit: 7,
        noDataAvailablePlaceholderText: 'No Data Found',
        searchPlaceholderText:"Search Hotel Code / Name"
      };
  }
 
  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.getRateTOPMS()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          
          // if (data.length < 1) {
          //   this.toastr.error('Property is not activated with Channel manager');
          // }
          //Remove duplicate data
          this.apiresult = data;
          this.hotellistproperty = this.apiresult;
          this.dropdownDeptData = this.apiresult;
          console.log('Property 113 = ', data)

          this.ColumnHeader = true;
          this.isProgressing = false;
        });


  }

  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if(this.selectedDeptItems){
      this.searchBarFilter = false
      this.searchText = '';
    if(this.selectedDeptItems.length > 0){
      console.log('if condition')
      this.Pmscodevalue = this.selectedDeptItems[0].pmscode
      console.log('pms code value = ',this.Pmscodevalue)
      this.errorMsgSubscription = true
      this.errorMessage = "Please select property and load"
      this.displayContent = false
      this.addBtnDisabledFunc = false
      var result=this.apiresult.filter((obj: { pmscode: MatSelectChange; })=> obj.pmscode == this.Pmscodevalue);
      console.log('filter record = ',result);
      this.lstgetcmlist = result;
      this.selectedChannel = this.lstgetcmlist[0].cmcode;
      // For Online Status
     this.apiCallIdsService
     .readHotelSearch(this.Pmscodevalue)
     .subscribe((data) => {
       console.log('readHotelSearch =',data)
       this.hotelSearchDataStatus = data[0].recordstatus
       this.productType = data[0].producttype
     });
       this.apiCallIdsService
       .readHeartbeat(this.Pmscodevalue)
       .subscribe((data) => {
         console.log('readHeartbeat =',data[0])
         this.heartBeatData = data[0].heartBeat

         // For blinking the record
        const today = new Date()
        console.log('Today Date = ',today);
        this.currentDateStore = today.toLocaleTimeString('it-IT')
        console.log('Today Date = ',this.currentDateStore);
        this.storeHeartBeatValue = this.GetParseonlyDateTime(this.heartBeatData)
        var start = this.storeHeartBeatValue.split(":");
        var end = this.currentDateStore.split(":");
        var startDate = new Date(0, 0, 0, start[0], start[1], 0);
        var endDate = new Date(0, 0, 0, end[0], end[1], 0);
        var diff = endDate.getTime() - startDate.getTime();
        var hours = Math.floor(diff / 1000 / 60 / 60);
        diff -= hours * 1000 * 60 * 60;
        var minutes = Math.floor(diff / 1000 / 60);
        // console.log('minutes difference',minutes)
        console.log('minutes difference', hours + ":"  + minutes)
        if((hours + ":"  + minutes) > "0:30"){
          console.log('blinkOfflineHotel true')
          this.blinkOfflineHotel = true
        }else{
          console.log('blinkOfflineHotel false')
          this.blinkOfflineHotel = false
        }
       });
      interval(2000 * 60).subscribe(() => {
        this.heartbeatFunction();
      });
    }else{
      console.log('Else condition zero')
      this.errorMsgSubscription = true
      this.errorMessage = "Please select property and load"
      this.displayContent = false
      this.addBtnDisabledFunc = true
    }
  }else{
    console.log('Property Not Selected')
  }
  }

  heartbeatFunction(){
    this.apiCallIdsService
    .readHeartbeat(this.Pmscodevalue)
    .subscribe((data) => {
      console.log('readHeartbeat =',data[0])
      this.heartBeatData = data[0].heartBeat
    });
  }


  GetParseonlyDateTime(d:any) {
    console.log('GetParseonlyDateTime call',d.substring(12))
    return (d.substring(12));
  }
  Search(event:any) {
    console.log('event= ', event)
    this.apiresult = this.hotellistproperty.filter((res: { pmscode: { toString: () => string; }; pmsname: { toString: () => string; }}) => {
      return res.pmscode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.pmsname.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase());
    });
      if(event == ''){
        this.Val = '';
        this.callIDSUsersProperties();
      }
  }
  SearchChannel(event) {
    console.log('event= ', event)
    if (this.Val != '')
      this.lstgetcmlist = this.hotellistChannel.filter(res => {
        return res.cmname.toLocaleLowerCase().match(this.Val.toLocaleLowerCase());
      });
  }

  pageEvent(e:any) {
    console.log(e)
    var pageIndex = e.pageIndex;
    this.pageIndex = pageIndex;
    console.log(this.pageIndex)
    this.pageSize = e.pageSize
    console.log(this.pageSize)
    //alert('Pagesize = '+ this.pageSize)
    this.PGF = this.pageSize * pageIndex + 1;
    this.PGT = this.PGF + e.pageSize - 1;
    if (this.pageSize != 0) {
      this.isProgressing = true;
      this.callRateSyncLogs();
    }
  }
  loadMethodForRateSyncLog() {
    this.searchBarFilter = true
    console.log(this.selectedDate)
    console.log(this.selectedTOODate)
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');
    }
    else {
    console.log(this.pageIndex)
    console.log(this.PGF)
    console.log(this.PGT)
    // if(this.pageIndex != 0){
    //   console.log('inside condition = '+ index)
    //   this.setPage(index)
    // }
    
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    this.isProgressing = true;
    this.PGF = 0;
    this.PGT = 50;
    // this.pageSize = 50;
    // this.paginator.pageIndex = 0;
    console.log(this.pageSize)
    console.log(this.PGF)
    console.log(this.PGT)
    // this.pageEvent(Event)
    // @ViewChild(MatPaginator, { static: false } ) paginator: MatPaginator;
    // this.paginator.pageIndex = 0;
    this.selectedChannel = ""
    console.log(" selectedProperty<------->" + this.selectedProperty + " CMCODE<------->" + this.source + " selectedDate<------->" + this.selectedDate + " selectedTooDate<------->" + this.selectedTOODate + " PGF<------->" + this.PGF + " PGT<------->" + this.PGT)
    this.apiCallIdsService.GetRateReportChannel(this.source, this.Pmscodevalue,this.selectedChannel, this.selectedDate, this.selectedTOODate, this.echoToken, this.PGF, this.PGT,this.searchText)
      .subscribe((res) => {
        this.StorelstRestr = res;
        console.log(this.StorelstRestr)
        if (this.StorelstRestr[0].totalrows < 1) {
          this.toastr.error('No Data Found');
          this.totalcount = this.StorelstRestr[0].totalrows;
          console.log(this.totalcount)
          this.ColumnHeader = false;
          this.errorMsgSubscription = true
          this.errorMessage ="No Data Found"
            this.displayContent = false
          this.isProgressing = false;

        } else {
          console.log(this.StorelstRestr)
          this.totalcount = this.StorelstRestr[0].totalrows;
          console.log(this.totalcount)
          this.idsProductList = res;
        this.dataSource = new MatTableDataSource(this.idsProductList);
        this.dataSource.paginator = this.paginator;
          this.errorMsgSubscription = false
            this.displayContent = true
          this.toastr.success('Data loaded Successfully');
          this.ColumnHeader = false;
          this.isProgressing = false;
        }
        this.errorMsgDisplay = false
      },
        error => {
          console.log(JSON.stringify(error))
          this.totalcount = this.StorelstRestr[0].totalrows;
          this.toastr.error(JSON.stringify(error.name) + ':' + JSON.stringify(error.status) + ' ' + JSON.stringify(error.statusText));
          this.errorMsgDisplay = true
          this.errorResponse = JSON.stringify(error.message)
          this.isProgressing = false;
        }
      );
    }
  }
  setPage(index: number) {
    console.log('setpage = '+index)
    this.paginator.pageIndex = index;
  }
  callRateSyncLogs() {
    console.log(this.selectedDate)
    console.log(this.selectedTOODate)
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    this.isProgressing = true;
    // this.PGF = "0";
    // this.PGT = "50";
    this.selectedChannel = ""
    console.log(" selectedProperty<------->" + this.Pmscodevalue + " CMCODE<------->" + this.source + " selectedDate<------->" + this.selectedDate + " selectedTooDate<------->" + this.selectedTOODate + " PGF<------->" + this.PGF + " PGT<------->" + this.PGT)
    this.apiCallIdsService.GetRateReportChannel(this.source, this.Pmscodevalue,this.selectedChannel, this.selectedDate, this.selectedTOODate, this.echoToken, this.PGF, this.PGT,this.searchText)
      .subscribe((res) => {
        this.StorelstRestr = res;
        if (this.StorelstRestr[0].totalrows < 1) {
          this.toastr.error('No Data Found');
          this.totalcount = this.StorelstRestr[0].totalrows;
          console.log(this.totalcount)
          this.ColumnHeader = false;
          this.isProgressing = false;

        } else {
          console.log(this.StorelstRestr)
          this.totalcount = this.StorelstRestr[0].totalrows;
          console.log(this.totalcount)
          this.idsProductList = res;
        this.dataSource = new MatTableDataSource(this.idsProductList);
        this.dataSource.paginator = this.paginator;
          this.toastr.success('Data loaded Successfully');
          this.ColumnHeader = false;
          this.isProgressing = false;
        }
        this.errorMsgDisplay = false
      },
        error => {
          console.log(JSON.stringify(error))
          this.totalcount = this.StorelstRestr[0].totalrows;
          this.toastr.error(JSON.stringify(error.name) + ':' + JSON.stringify(error.status) + ' ' + JSON.stringify(error.statusText));
          this.errorMsgDisplay = true
          this.errorResponse = JSON.stringify(error.message)
          this.isProgressing = false;
        }
      );
  }
  clearHotelAutoComplete() {
    this.searchText = ''
  }

  FOOTFALL() {
    this.User = localStorage.getItem("Username");
    this.apiCallIdsService.getfootfall(this.User, 'Channel manager', 'restriction').subscribe(
      data => {
      });
  }

  closeModalDialog() {
    this.display = false; 
  }

  fromDateChange(data: any) {
    console.log(data)
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    if (this.selectedTOODate < this.selectedDate) {
      this.toastr.error('From date should be less than To date.');
    }
  }
 

  // Rate XML loading
  showXml(condition:any,xmltype: any, token: any) {
    console.log(xmltype)
    if(condition == ''){
      this.status=this.LoadXML(xmltype, token);
    }else{
      this.isProgressing = true;
      this.apiCallIdsService.loadXMLData(token)
      .subscribe((res) => {
        console.log('Response =',res.content)
        if(xmltype == 'ReceivedXML'){
          this.XMLTitle =  "Received XML"
           }else if(xmltype == 'PostedXML'){
            this.XMLTitle =  "Posted XML"
           }else if(xmltype == 'DHAckResponse'){
            this.XMLTitle =  "DHAckResponse XML"
           }else if(xmltype == 'CMAcknowledgement'){
            this.XMLTitle =  "CM Acknowledge XML"
           }
        const xml = beautify(res.content);
       console.log('Beautifier',xml);
       this.defaultData = xml;
       this.display=true;
       this.isProgressing = false;
        
      })
    }
    }

LoadXML(xmltype: any, token: any) {
  //alert(token)
  this.isProgressing = true;
 console.log(this.Pmscodevalue,'=',this.selectedChannel,'=',xmltype,'=',token,'=',this.source,'end')
 if(xmltype == 'ReceivedXML'){
this.XMLTitle =  "Received XML"
 }else if(xmltype == 'PostedXML'){
  this.XMLTitle =  "Posted XML"
 }else if(xmltype == 'DHAckResponse'){
  this.XMLTitle =  "DHAckResponse XML"
 }else if(xmltype == 'CMAcknowledgement'){
  this.XMLTitle =  "CM Acknowledge XML"
 }
  this.apiCallIdsService.getRateToChannelXML(this.Pmscodevalue,this.selectedChannel,xmltype,token,this.source)
      .subscribe(data => {
console.log(data)
        if(data.length<1)
          {
            this.toastr.error('No data to load');
            this.isProgressing = false;
          }
           if(data[0].xmlData == null){
            this.toastr.error('No XML Data Found');
            this.isProgressing = false;
           }else{
            const xml = beautify(data[0].xmlData);
           console.log(xml);
           this.defaultData = xml;
           this.display=true;
           this.isProgressing = false;
           }
           
          },
         error => {
          console.log(error)
          this.toastr.error(JSON.stringify(error.name) +':' + JSON.stringify(error.status) +' '+JSON.stringify(error.statusText));
            this.isProgressing = false;
      },
      
      );
}
}
